"use client"

import { MessageCircle } from "lucide-react"
import { whatsappUrl } from "@/lib/contact"

interface WhatsAppFabProps {
  dict: {
    aria_label: string
    message: string
  }
}

export function WhatsAppFab({ dict }: WhatsAppFabProps) {
  return (
    <a
      href={whatsappUrl(dict.message)}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#25D366] text-white shadow-2xl shadow-green-500/40 transition-all hover:scale-110 hover:-translate-y-1 active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2 overflow-hidden group"
      aria-label={dict.aria_label}
    >
      {/* Pulse Effect */}
      <span className="absolute inset-0 animate-ping rounded-2xl bg-[#25D366] opacity-20 group-hover:hidden" />
      
      <MessageCircle className="h-8 w-8 relative z-10 transition-transform group-hover:rotate-12" />
      
      {/* Gloss Effect */}
      <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/20 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity" />
    </a>
  )
}
